import { color, typeStyle, units } from '@m/alchemy-ui/theme';
import styled from 'styled-components';

export const Background = styled.div`
  background-color: ${color('canvas')};
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -100;
`;

export const FiltersContainer = styled.div`
  display: grid;
  gap: ${units(2)} ${units(3)};
  grid-template-columns: repeat(auto-fit, minmax(max(18%, 244px), 1fr));
  label {
    ${typeStyle('labelM')};
    color: ${color('typeSubHeader')};
  }
  [data-testid='clear-filters'] {
    grid-column: -2/-1;
  }
`;

export const PageContainer = styled.div`
  margin: 0 5vw;
`;

export const PageTitle = styled.h1`
  ${typeStyle('dataL')};
  line-height: 60px;
`;

export const PageSubtitle = styled.h3`
  ${typeStyle('actionM')};
  color: ${color('typeMeta')};
`;
